<template>
  <div
    class="yotpo-widget-instance yotpo"
    :data-yotpo-instance-id="yotpoInstanceId"
    :data-yotpo-product-id="product.id"
    :data-yotpo-section-id="templateName"
  />
</template>

<script>
export default {
  props: {
    product: {
      type:Object,
      default: null
    }
  },
  computed: {
    yotpoPermanantDomain () {
      return window.theme.shop.permanantDomain
    },
    yotpoProductUrl () {
      return `${window.theme.shop.url}/products/${this.product.handle}`
    },
    yotpoAppKey () {
      return window.theme.yotpo.appKey
    },
    templateName () {
      const body = document.body
      if (document.body.classList.contains('template-index')) {
        return 'index'
      } else if (body.classList.contains('template-product')) {
        return 'product'
      } else {
        return 'collection'
      }
    },
    yotpoInstanceId () {
      if (window.theme.shop.permanentDomain === 'sneak-gaming.myshopify.com') {
        return '537592'
      } else if (window.theme.shop.permanentDomain === 'sneak-eu.myshopify.com') {
        return '528897'
      } else {
        return '498650'
      }
    }
  },
}
</script>
